/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/* Fix Search 192890 */
const searchTerm = window.location.search;
if (searchTerm.length > 5 && searchTerm.indexOf('\+') !== -1) {
  let newSearchTerm = searchTerm.replace('type=product&', '').replace(/\+/g,'%20');
  if(newSearchTerm.slice(-1) === '*') {
    newSearchTerm = newSearchTerm.slice(0, -1);
  }
  let newUrl = window.location.href.replace(searchTerm, newSearchTerm)
  window.location.replace(newUrl);
}
/* End Fix Search 192890 */